import React from 'react';
import {connect} from 'react-redux';
import styled from 'styled-components';
import {bindActionCreators} from "redux";
import {withRouter} from 'react-router-dom';

import * as actions from '../sample.actions';
import * as selectors from '../sample.selectors';
import {PageSection, WarningButton, PrimaryButton} from '../../../components/index'
import * as applicationSelectors from '../../../application.selectors';
import {ReviewsDataGrid} from "../components/index";
import Filters from "../components/Filters";

const Container = styled.div`
`;

class ReviewsContainer extends React.Component {

  onPatientClick = (recordId) => () =>
    this.props.history.push(`/records/${this.props.period.id}/${recordId}`);

  Actions = ({data: {id, recordStatus}}) => (<div>
    {recordStatus !== 'Complete' 
      ? <WarningButton className="btn-sm" onClick={this.onPatientClick(id)}>Review</WarningButton>
      : <PrimaryButton className="btn-sm" onClick={this.onPatientClick(id)}>View</PrimaryButton>}
  </div>);

  render() {
    const {facilities, patients, reviewers, recordStatuses} = this.props;

    return (
      <Container>
        <PageSection title="Perform PASRR Reviews">
          <Filters
            others
            filters={this.props.filters}
            facilities={facilities}
            reviewers={reviewers}
            recordStatuses={recordStatuses}
            search={this.props.actions.setFilters}
            clear={this.props.actions.clearFilters}
          />
          <ReviewsDataGrid
            height={596}
            pageSize={300}
            patients={patients}
            actionsRenderer={this.Actions}
          />
        </PageSection>
      </Container>
    );
  }
}

export default withRouter(
  connect(
    (state) => ({
      filters: selectors.filters(state),
      period: selectors.currentPeriod(state),
      facilities: selectors.facilities(state),
      patients: selectors.includedPatients(state),
      reviewers: applicationSelectors.reviewers(state),
      recordStatuses: selectors.allRecordStatus(state)
    }),
    dispatch => ({
      actions: bindActionCreators({...actions}, dispatch)
    })
  )(ReviewsContainer)
);



// WEBPACK FOOTER //
// ./src/modules/sample/admin/ReviewsContainer.js